module.exports = __webpack_public_path__ + "static/L2_ux_5_2_eg-79de224333ed1de200d1eed7090ede34.png";